import { QuestionBase } from './question-base.model';

export class CaptchaQuestion extends QuestionBase<string> {
   controlType = 'recaptcha';
   objectData: string;
   name: any;
   type: any;
   recaptcha: any;
   constructor(options: {} = {}) {
      super(options);
      this.name = options['name'] || '';
      this.recaptcha = options['recaptcha'];
      this.type = options['type'] || 'string';
   }
}